import * as Content from '../content';

export const contentService = {
  getTaskStatusses: Content.getTaskStatusses,
  getTaskStatusLabel: Content.getTaskStatusLabel,
  getTaskStatusIcon: Content.getTaskStatusIcon,
  getInclusionRequestStatusses: Content.getInclusionRequestStatusses,
  getInclusionRequestStatusLabel: Content.getInclusionRequestStatusLabel,
  getInclusionRequestStatusIcon: Content.getInclusionRequestStatusIcon,
  getBeoordelingStatusLabel: Content.getBeoordelingStatusLabel,
  getBeoordelingStatusIcon: Content.getBeoordelingStatusIcon,
  getBeoordelingStatusDescription: Content.getBeoordelingStatusDescription,
  messages: Content.messages,
  labels: Content.labels,
};
